<div class="viewer-controller-select rt-input">
  <div
    class="viewer-controller-select__main"
    [matMenuTriggerFor]="menu"
  >
    <div class="viewer-controller-select__icon">
      <ng-content></ng-content>
    </div>

    <div class="viewer-controller-select__name">
      {{ viewName }}
    </div>
  </div>

  <mat-menu #menu="matMenu" class="mat-menu_no-padding">
    @for (choice of choices; track $index) {
      <button
        mat-menu-item
        class="viewer-controller-select__option"
        [ngClass]="{'viewer-controller-select__option_selected': choice[0] === choicesControl.value}"
        (click)="selectChoice(choice[0])"
      >
        {{choice[1]}}
      </button>
    }
  </mat-menu>
</div>
